'use strict';

import * as THREE from 'three';
import TWEEN from '../../libs/tween.umd';
import {
  autoRotateTimerAction,
  getCurrentCameraDistance, getOrbitControlsCurrentPolarAngle,
  getOrbitControlsDistanceAndPan,
  getPolarAngleFromViewMode,
  getWorldData, setMinAndMaxControlsDistance,
} from '../controls/orbitControls';
import { settingsData, threeJsVariables } from '../../settings';
import { animateCamera } from '../threejs/animation';
import { Vector3 } from 'three';
import { createHtmlElement, userPrevent } from '../../functions';
import { ViewMode } from '../../common';
import {stopCameraTour} from "../camera-auto-tour/cameraTour";

export function compassInit (container = document.body) {
  const compassContainer = createHtmlElement(container,'','div',['compass-container']);
  const compassBtn = createHtmlElement(compassContainer,'','button',['compass', 'icon-compas']);
  compassBtn.setAttribute('data-type', 'compass');
  // compassBtn.innerHTML = `
  //       <span class="ic path1"></span>
  //       <span class="ic path2"></span>
  //       <span class="ic path3"></span>`;

  compassBtn.addEventListener('click', compassClickHandler);
  compassRotation();
}

let _compasVector = new THREE.Vector3()
let _compasSphere = new THREE.Spherical();
let _compasEl = null
export function compassRotation (compassCorrection = config.threejs.compass.correction) {
  const {cameraVector,orbitControlsVector} = getWorldData();
  _compasVector.copy(cameraVector).sub(orbitControlsVector);

  _compasSphere.setFromVector3( _compasVector );
  const rot = _compasSphere.theta - compassCorrection;

  if (_compasEl===null){
    _compasEl = document.querySelector('.compass');
  }
  if (_compasEl){
    _compasEl.style.transform = 'rotate('+ rot +'rad)';
  }

}

export function compassClickHandler() {
  if (settingsData.tourIsActive) {
    stopCameraTour();
  }

  if (userPrevent()) return;

  autoRotateTimerAction('update');

  const {cameraVector,orbitControlsVector} = getWorldData();
  const {minAngle,maxAngle} = getPolarAngleFromViewMode();
  const defaultPos = config.threejs.animations.defaultForeshortening.position;
  const defaultVector = new THREE.Vector3(defaultPos.x,defaultPos.y,defaultPos.z);
  const {minDistance} = getOrbitControlsDistanceAndPan();
  const currentDistance = getCurrentCameraDistance();
  const currentPolarAngle = getOrbitControlsCurrentPolarAngle();

  const axis = new THREE.Vector3(0,-1,0).normalize();
  const normalizeDefaultVector = new Vector3().copy(defaultVector).normalize().setLength(currentDistance);

  let orbitTarget;

  if (settingsData.activeViewMode === ViewMode.Orbit){
    const defaultOrbitControlsTarget = config.threejs.orbitControls.target;
    orbitTarget = new Vector3(defaultOrbitControlsTarget.x,defaultOrbitControlsTarget.y,defaultOrbitControlsTarget.z);
  } else {
    orbitTarget = orbitControlsVector;
  }

  const northVector = normalizeDefaultVector.applyAxisAngle(axis, config.threejs.compass.northAngle).add(orbitTarget);

  animateCamera(
    cameraVector,
    northVector,
    orbitControlsVector,
    orbitTarget,
    undefined,
    currentDistance,
    currentPolarAngle,
    undefined,
    1000,
    TWEEN.Easing.Sinusoidal.InOut,
    ()=>{
      threeJsVariables.orbitControls.maxPolarAngle = currentPolarAngle;
      threeJsVariables.orbitControls.minPolarAngle = currentPolarAngle;
    },
    ()=>{
      threeJsVariables.orbitControls.setPolarAngle(currentPolarAngle);
      threeJsVariables.orbitControls.maxPolarAngle = maxAngle;
      threeJsVariables.orbitControls.minPolarAngle = minAngle;
      setMinAndMaxControlsDistance();
    }
  );
}

/**
 * Change compass position in landscape mode when building destroyed
 */

export const compassPositionChange = (moveDirection) => {
  return;
  if (!settingsData.isLandscape) return;
  const bottomNavBar = document.querySelector('.bottom__nav-bar');
  const currentDirection = document.documentElement.getAttribute('dir');

  if (currentDirection === 'rtl' && settingsData.buildingDestroyed) {
    bottomNavBar.style.left = '100px';
    bottomNavBar.style.right = 'initial';
  } else if (currentDirection === 'ltr' && settingsData.buildingDestroyed) {
    bottomNavBar.style.right = '100px';
    bottomNavBar.style.left = 'initial';
  } else if (!settingsData.buildingDestroyed) {
    bottomNavBar.removeAttribute('style');
    bottomNavBar.style.opacity = '1';
  }

  // switch (moveDirection) {
  //   case 'left':
  //     bottomNavBar.style.left = '100px';
  //     break;
  //   case 'right':
  //     bottomNavBar.style.right = '100px';
  //     break;
  //   case 'default':
  //     bottomNavBar.removeAttribute('style');
  //     bottomNavBar.style.opacity = '1';
  //     break;
  // }
}

export function compassVisibleToggle (action) {
  const compassContainer = document.querySelector('.compass-container');

  switch (action) {
    case 'show':
        compassContainer.classList.remove('hidden');
      break;
    case 'hide':
      compassContainer.classList.add('hidden');
      break;
  }

}